import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=04e38e46"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e38e46')) {
      api.createRecord('04e38e46', component.options)
    } else {
      api.reload('04e38e46', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=04e38e46", function () {
      api.rerender('04e38e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/entry/inform/detail.vue"
export default component.exports